// import { combineReducers } from 'redux'

// import { ILocaleState } from '../types'
// import communications from './communications'
import data from './data'

export const reducer = data
